/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, message, DatePicker, Form } from 'antd'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'


class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
            isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, complain, saveComplainSettlementAward, onClose } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
            
            if (complain) {
				values = Object.assign({}, values, { complain_uid: complain.uid, barangay_uid })
            }
            
            // console.log('values', values)

			message.loading({ key: 'set_complain_settlement', content: 'Saving, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveComplainSettlementAward(values).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_complain_settlement', content: 'Successfully saved.' })

					const auditParams = {
                        module_name: 'Complains',
                        action: 'Update',
                        message: `Update complain settlement or award details with case no ${complain.case_no}`
                    }
                    AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving complain settlement')
					message.error({ key: 'set_complain_settlement', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
        const { isSaving } = this.state
		const { form, complain } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Form onSubmit={this.handleSubmit}>
                <Row>
                    <Form.Item label='Main Point of Agreement'>
                        { getFieldDecorator('main_agreement', {
                            initialValue: (complain) ? complain.main_agreement : null,
                            rules: [{
                                required: false,
                                message: 'This field is required.'
                            }, {
                                validator: (rule, value, callback) => {
                                    if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
                                        callback('only white space detected.')
                                    }
                                    callback()
                                }
                            }]
                        })
                        (
                            <Input.TextArea rows={4} placeholder='Enter main point of agreement' />
                        )}
                    </Form.Item>
                </Row>
                <Row>
                    <Form.Item label='Remarks'>
                        { getFieldDecorator('end_remarks', {
                            initialValue: (complain) ? complain.end_remarks : null,
                            rules: [{
                                required: false,
                                message: 'This field is required.'
                            }, {
                                validator: (rule, value, callback) => {
                                    if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
                                        callback('only white space detected.')
                                    }
                                    callback()
                                }
                            }]
                        })
                        (
                            <Input.TextArea rows={4} placeholder='Enter closing remarks' />
                        )}
                    </Form.Item>
                </Row>
                <Row gutter={24}>
                    <Col md={12} sm={24}>
                        <Form.Item label='Date of Settlement or Award'>
                            { getFieldDecorator('date_settlement', {
                                initialValue: (complain && complain.date_settlement) ? moment(complain.date_settlement) : null,
                                rules: [{
                                    required: false,
                                    message: 'This field is required.'
                                }]
                            })
                            (
                                <DatePicker format='LL' showTime style={{ width: '100%' }}/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col md={12} sm={24}>
                        <Form.Item label='Date of Execution of Settlement or Award'>
                            { getFieldDecorator('date_execution_settlement', {
                                initialValue: (complain && complain.date_execution_settlement) ? moment(complain.date_execution_settlement) : null,
                                rules: [{
                                    required: false,
                                    message: 'This field is required.'
                                }]
                            })
                            (
                                <DatePicker format='LL' showTime style={{ width: '100%' }}/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row type='flex' justify='center' style={{ marginBottom: 20 }}>
                    <button 
                        disabled={isSaving}
                        type="button" 
                        className="btn btn-success btn-rounded waves-effect waves-light"
                        onClick={this.handleSubmit}
                    >
                        <i className='mdi mdi-file-plus'/> Save Details
                    </button>
                </Row>
            </Form>
		)
	}
}

const SET_COMPLAIN_SETTLEMENT = gql`
    mutation setComplainSettlementAward($input: JSON) {
		setComplainSettlementAward(input: $input)
    }
`

const composed = compose(
	withRouter,
	Form.create({ name: 'form-update-settlement' }),
	inject('AuthStore'),
	graphql(SET_COMPLAIN_SETTLEMENT, {
		props({ mutate }) {
			return {
				saveComplainSettlementAward(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplainByUid']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
